// =============================================================================
//  Copyright : 2020 semantics GmbH
//  Date      : $Date: 2025-09-21 19:16:35 +0200 (Sun, 21 Sep 2025) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 156393 $
//  Purpose   : parts for help system
// =============================================================================
// ---Third-party imports

import React from 'react'
import {Segment, Label, Menu, Header} from 'semantic-ui-react'

// ---Framework imports
import {mapItems} from 'ldash'
import {Actions, Sel} from 'uix/registries'
import {funcPart, StandalonePart} from 'uix/parts'
import {useSelector, useState, useApi, useActions, useEffect} from 'uix/hooks'
import log from 'uix/logging'
import {ResizableDialog, XMenu} from 'uix/components'
import {WikiPane} from 'uix/wiki/render'
import {AclFeature} from 'uix/auth/components'

// ---Local imports
import S from './help.scss'

// ---Globals

const HelpWiki = ({wikiident}) => {
  let navigateHelp = useActions(Actions.navigateHelp)
  let request = useSelector(Sel.request)
  let mainIdent = `help/${request.classname}_${request.tabname}`
  let navIdent = useSelector(root => root.meta.contextHelp.navigation[mainIdent])

  let identifier = wikiident || navIdent || mainIdent
  let preview = useSelector(root => root.data.wiki.preview[`WikiEditorDialog_${identifier}`])

  let [dlgOpen, setDlgOpen] = useState(false)
  // always refresh data on dlg-open-state change
  let {data, error} = useApi(
    'filter/getWikiRendered',
    {ident: identifier},
    {deps: dlgOpen, autoreset: false}
  )

  let rendered = preview?.rendered || data?.wiki.rendered

  let editor = null
  if (dlgOpen) {
    editor = (
      <ResizableDialog name="WikiEdit" onClose={() => setDlgOpen(false)}>
        <StandalonePart
          type="WikiEditor"
          name="WikiEditorDialog"
          storeKey={identifier}
          params={{identifier}}
        />
      </ResizableDialog>
    )
  }

  return (
    <div className={S.help}>
      <div className={S.topMenu}>
        <XMenu>
          <AclFeature acl="g:admin">
            {editor}
            <Menu.Item icon="edit" active={dlgOpen} onClick={() => setDlgOpen(!dlgOpen)} />
          </AclFeature>
          <Menu.Item
            icon="home"
            disabled={!navIdent}
            onClick={() => navigateHelp(mainIdent, null)}
          />
        </XMenu>
      </div>
      <div className="wikiblock" style={{padding: '0.6rem'}}>
        <Segment secondary>
          <WikiPane rendered={rendered} identifier={identifier} />
        </Segment>
      </div>
    </div>
  )
}

const PartList = ({}) => {
  let measureParts = useActions(Actions.measureParts)
  useEffect(() => {
    measureParts('contextHelp')
  }, [])
  let partMeasurements = useSelector(root => root.debug.partMeasurements['contextHelp'])
  let parts = mapItems(partMeasurements, (name, xx) => {
    return <div key={name}>{name}</div>
  })
  return <div>{parts}</div>
}
// Fake Help Area
export const ContextHelp = ({...props}) => {
  return <HelpWiki {...props} />
}
